import React, { useState, useEffect } from "react";
import DynamicIcon from './DynamicIcon';




const BoosterCarousel = ({windowWidth}) => {
  const itemsPerPage = Number(`${windowWidth > 900 ? 3 : windowWidth > 500 ? 2 : 1}`)
const itemsPerRow = Number(`${windowWidth > 900 ? 3 : windowWidth > 500 ? 2 : 1}`)
// const Carousel = ({ items }) => {
    const slides = [
      // {
      //   id: 1,
      //   title: "Winzerhotel Gumpoldskirchen",
      //   imageUrl: "https://www.seminargo.com/seminargo/image/6iajga/900_900/Seminar%20Presshaus%202.jpg",
      //   link: "https://www.seminargo.com/hotel/Winzerhotel_Gumpoldskirchen",
      // },
        {
          id: 15,
          title: "Eventhotel Pyramide",
          imageUrl: "https://www.seminargo.com/seminargo/image/8fek61/900_900/meeting16.jpg",
          link: "https://www.seminargo.com/hotel/Eventhotel_Pyramide",
        },
      {
        id: 2,
        title: "Werzers Hotel Resort Pörtschach",
        imageUrl: "https://www.seminargo.com/seminargo/image/0jhih5/900_900/",
        link: "https://www.seminargo.com/hotel/Werzers_Hotel_Resort_Pörtschach",
      },
        {
          id: 3,
          title: "Flugzeughotel NOVAPARK Graz",
          imageUrl: "https://www.seminargo.com/seminargo/image/9i9cih/900_900/_0004s_0017_b_c_Veranstaltungen_Foto%20NOVAPARK.jpg",
          link: "https://www.seminargo.com/hotel/NOVAPARK_Flugzeughotel_Graz",
        },
        {
          id: 4,
          title: "GABRIUM",
          imageUrl: "https://www.seminargo.com/seminargo/image/e849k3/900_900/Seminar%202573%20.JPG",
          link: "https://www.seminargo.com/hotel/GABRIUM",
        },
        {
          id: 5,
          title: "Refugium Hochstrass",
          imageUrl: "https://www.seminargo.com/seminargo/image/b4hb24/900_900/HOCHSTRASS_9970_maristella_pazifica_1500px.jpg",
          link: "https://www.seminargo.com/hotel/Refugium_Hochstrass",
        },
        {
          id: 6,
          title: "Seewirt Haus Attila",
          imageUrl: "https://www.seminargo.com/seminargo/image/22dch/900_900/Seminar%20SEE017%20by%20steve%20haider%202012.jpg",
          link: "https://www.seminargo.com/hotel/Seewirt_Haus_Attila",
        },
        {
          id: 7,
          title: "Aldiana Club Ampflwang",
          imageUrl: "https://www.seminargo.com/seminargo/image/1a1886a/900_900/OOE_Tagung_0001.jpg",
          link: "https://www.seminargo.com/hotel/Aldiana_Club_Ampflwang",
        },
        {
          id: 8,
          title: "Aldiana Club Salzkammergut",
          imageUrl: "https://www.seminargo.com/seminargo/image/8h85ge/900_900/SKT_Tagungsraum_0001.jpg",
          link: "https://www.seminargo.com/hotel/Aldiana_Club_Salzkammergut",
        },
        {
          id: 9,
          title: "Wachauerhof",
          imageUrl: "https://www.seminargo.com/seminargo/image/gkfab6/900_900/IMG_3200.JPG",
          link: "https://www.seminargo.com/hotel/Wachauerhof",
        },
        {
          id: 10,
          title: "Kasematten Wiener Neustadt",
          imageUrl: "https://www.seminargo.com/seminargo/image/jadd05/900_900/Neue%20Bastei%20Theater.jpg",
          link: "https://www.seminargo.com/hotel/Kasematten_Wiener_Neustadt",
        },
        {
          id: 11,
          title: "Mercure Grand Hotel Biedermeier Wien",
          imageUrl: "https://www.seminargo.com/seminargo/image/b5099g/900_900/Raimund.jpg",
          link: "https://www.seminargo.com/hotel/Mercure_Grand_Hotel_Biedermeier_Wien",
        },
        {
          id: 12,
          title: "Hotel im Wald Hammerschmiede",
          imageUrl: "https://www.seminargo.com/seminargo/image/516djg/900_900/180806hammerschmiede0345.jpg",
          link: "https://www.seminargo.com/hotel/Hotel_im_Wald_Hammerschmiede",
        },
        {
          id: 13,
          title: "REDUCE HOTEL VITAL Bad Tatzmannsdorf",
          imageUrl: "https://www.seminargo.com/seminargo/image/6g2gf9/900_900/Seminarraum%20Pavel%20Laurencik%20DSC_0834_farbgestimmt.jpg",
          link: "https://www.seminargo.com/hotel/REDUCE_HOTEL_VITAL_Bad_Tatzmannsdorf",
        },
        {
          id: 14,
          title: "Pannonia Tower Hotel Parndorf",
          imageUrl: "https://www.seminargo.com/seminargo/image/98f1cc/900_900/Panonia%20Towers.jpg",
          link: "https://www.seminargo.com/hotel/Pannonia_Tower_Hotel_Parndorf",
        },
        {
          id: 16,
          title: "THERMENWELT Hotel PULVERER",
          imageUrl: "https://www.seminargo.com/seminargo/image/gh74gj/900_900/seminar94.jpg",
          link: "https://www.seminargo.com/hotel/THERMENWELT_Hotel_PULVERER",
        },
        {
          id: 17,
          title: "IntercityHotel Graz",
          imageUrl: "https://www.seminargo.com/seminargo/image/8abhdf/900_900/ICH_Graz_Konferenz_Thalerhof_8315.jpg",
          link: "https://www.seminargo.com/hotel/IntercityHotel_Graz",
        },
        {
          id: 18,
          title: "SCHEIBLHOFER THE RESORT",
          imageUrl: "https://www.seminargo.com/seminargo/image/9gicjg/900_900/DSC07887-ret-min.jpg",
          link: "https://www.seminargo.com/hotel/SCHEIBLHOFER_THE_RESORT",
        },
        {
          id: 19,
          title: "Narzissendorf Zloam",
          imageUrl: "https://www.seminargo.com/seminargo/image/038eg2/900_900/3_Zloam_Seminar_KS.jpg",
          link: "https://www.seminargo.com/hotel/Narzissendorf_Zloam",
        },
        {
          id: 22,
          title: "Max Brown 7th District",
          imageUrl: "https://www.seminargo.com/seminargo/image/6f1g1e/900_900/Atelier%201_01.jpg",
          link: "https://www.seminargo.com/hotel/Max_Brown_7th_District",
        }
      ];
  const [currentPage, setCurrentPage] = useState(1);
//   const [slides, setSlides] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

//   useEffect(() => {
//     setIsLoading(true);
//     fetch(apiUrl) 
//     .then((response) => response.json()) 
//         .then(data => {
//           setSlides(data);
//         setIsLoading(false);
//       })
//       .catch(err => {
//         setError(err);
//         setIsLoading(false);
//       });
//   }, [apiUrl]);

//   function findFirstImageUrl(text) {
//     const fallbackUrl = 'https://example.com/default-image.jpg'
//     const regex = /<img\s+[^>]*?src=(['"])(.*?)\1/i; // Define a regular expression to match the image tag and capture just the URL
//     // const regex = /<img\s+[^>]*?src=(['"])(.*?)\1[^>]*?>/i; // Define a regular expression to match the image tag and capture the entire element

//     const match = text.match(regex);
  
//     if (match) {
//       return match[2]; // Return the second element in the match array, which should be the captured URL
//       // return match[0]; // Return the entire matched string, which should be the captured image element

//     } else {
//       return fallbackUrl;
//     }
//   }

// slides.forEach((slide) => {
// const text = slide.content.rendered
// const firstImageUrl = findFirstImageUrl(text);
// slide.imageUrl = firstImageUrl
// slide.title.rendered = slide.title.rendered.replace('&#8211;', "-").slice(0, 100)+'...\nweiter lesen'
// })

// console.log('Slides:', slides)

// const clusters = slides.map((cluster, index) => 
// <div key={index} css={singleClusterBoxStyles}><a href={cluster.link}>{cluster.name}</a></div>)



  const totalPages = Math.ceil(slides.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const visibleItems = slides.slice(startIndex, endIndex);

  const handlePrevious = () => {
    setCurrentPage((prevPage) => prevPage - 1);
  };

  const handleNext = () => {
    setCurrentPage((prevPage) => prevPage + 1);
  };

  const renderRows2 = () => {
    const rows = [];

    for (let i = 0; i < visibleItems.length; i += itemsPerRow) {
      const rowItems = visibleItems.slice(i, i + itemsPerRow);
      rows.push(
        <div className="textRow" key={i}>
            {error && <div>{error}</div>}
    {isLoading && <div>Loading...</div>}
          {rowItems.map((item) => (
            <div className="text-wrapper" key={item.id}>
            <a href={item.link}>
            {/* <img src={item.imageUrl} alt={item.title} /> */}
            <div 
            className="item"
            style={{backgroundImage: `linear-gradient(to bottom, transparent 80%, rgba(0,0,0,0.5)), url(${item.imageUrl})`, backgroundSize: 'cover', backgroundPosition: 'center'}} 
            key={item.id}
            >
              {/* <img src={item.imageUrl} alt={item.title.rendered} /> */}
              <span>{item.title}</span>
            </div>
            </a>
            </div>
          ))}
        </div>
      );
    }

    return rows;
  };

  return (
    <div className="carousel">
      {renderRows2()}
      <div className="controls">
        <button aria-label="previous" disabled={currentPage === 1} onClick={handlePrevious}>
          {/* Prev */}
          <DynamicIcon icon={"arrowCircleLeft"} id="icon"/>
        </button>
        <button aria-label="next" disabled={currentPage === totalPages} onClick={handleNext}>
          {/* Next */}
          <DynamicIcon icon={"arrowCircleRight"} id="icon"/>
        </button>
      </div>
    </div>
  );
};

export default BoosterCarousel;